var _style, _circle, _line, _line2, _circle2, _polyline, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenderSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#49e1ca;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 12,
    cy: 14.5,
    r: 5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 12,
    y1: 24.7,
    x2: 12,
    y2: 19.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 9.6,
    y1: 22.3,
    x2: 14.4,
    y2: 22.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 17.8,
    cy: 14.5,
    r: 5
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "21,7.3 25,7.3 25,11.4 "
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 25,
    y1: 7.3,
    x2: 21.7,
    y2: 10.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenderSelected);
export default __webpack_public_path__ + "static/media/genderSelected.7a3832454d80e9e0c7b4f4f3e036bdaf.svg";
export { ForwardRef as ReactComponent };